import { Form, Select } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import {
    SearchPanelFilterForm,
    SearchPanelFilterFormProps,
} from 'src/components/SearchPanel/SearchPanelFilterForm';
import { collateralTypeOptions } from 'src/pages/CollateralsPage/CollateralTypesMap';
import {
    CollateralsFilter,
    CollateralsStore,
} from 'src/stores/CollateralsStore/CollateralsStore';
import { FormHelper } from 'src/utils/FormHelper';
import styled from 'styled-components';

export const CollateralsHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <SearchPanel
            inputSearchFormName={formNames.getPath('filterSearch')}
            store={store}
            renderPanel={(props) => <FilterPanel {...props} />}
            inputSearchPlaceholder={t(
                'Page.Collaterals.AsideHeader.Search.Placeholder',
            )}
        />
    );
});

export const FilterPanel = observer((props: SearchPanelFilterFormProps) => {
    const { t } = useTranslation();

    return (
        <SearchPanelFilterForm
            {...props}
            onFinish={(values: CollateralsFilter) => {
                store.pager.reset();
                store.filterCriteria?.applyFilter(
                    convertFormValuesToFilterCriteria(values),
                );
                store.loadList();
            }}
        >
            <StyledFormItem
                label={t('Page.Collaterals.Filter.Type')}
                name={formNames.getPath('filterCollateralTypes')}
            >
                <Select
                    allowClear
                    mode="multiple"
                    data-testid="filterCollateralTypes"
                >
                    {collateralTypeOptions.map(({ id, title }) => (
                        <Select.Option
                            value={id}
                            key={id}
                            data-testid={`collaterals-type-option-${id}`}
                        >
                            {t(`data:collateralType.${title}`)}
                        </Select.Option>
                    ))}
                </Select>
            </StyledFormItem>
        </SearchPanelFilterForm>
    );
});

const store = CollateralsStore;
const formNames = FormHelper.createNameProvider<CollateralsFilter>();

const convertFormValuesToFilterCriteria = (
    values: CollateralsFilter,
): CollateralsFilter => {
    const { filterCollateralTypes, ...otherValues } = values;

    return {
        ...otherValues,
        filterCollateralTypes:
            filterCollateralTypes && filterCollateralTypes.length > 0
                ? filterCollateralTypes
                : undefined,
    };
};

const StyledFormItem = styled(Form.Item)`
    .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        display: flex;
        align-items: center;
        min-height: auto;
        border-radius: 0.5rem;
    }
`;
